var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isMobile } from "../../../../app/Routes";
import { GameOperationsSelect } from "../../widgets/selected";
import { initialLeftMenu, sportsMenu, dateTimeFormat, dateFormat } from "../../../../lib/misc.functions";
import { ApiService } from "../../../../lib/http.service";
import { env } from "../../../../definitions/global.vars";
import { Storage } from "../../../../lib/localstorege.service";
var STATUS_MAP = {
    0: { label: "Beklemede" },
    1: { label: "Oynandı" },
    2: { label: "Kazandı" },
    3: { label: "Kaybetti" },
    4: { label: "İptal" },
    6: { label: "İade" }
};
var DISCIPLINE_MAP = {
    "MATCHDAY SOCCER 3": "FUTBOL LİGİ",
    "SOCCER 3": "FUTBOL",
    "PRO LIG": "PRO LİG",
    "BASKETBALL": "BASKETBOL",
    "STOCK CARS": "ARABA YARIŞI",
    "LUCKY CARS": "ŞANSLI ARABALAR",
    "MARBLES": "MİSKET YARIŞI"
};
var VRGameCoupons = function () {
    var navigate = useNavigate();
    useEffect(function () {
        initialLeftMenu(false);
    }, [sportsMenu.isVisible]);
    return (_jsxs("div", __assign({ className: "widget card border-0 shadow-sm" }, { children: [_jsxs("div", __assign({ className: "header border-bottom p-3 d-flex justify-content-between align-items-center" }, { children: [isMobile ? _jsx(GameOperationsSelect, {}, void 0) : _jsx("h1", __assign({ className: "h5 mb-0" }, { children: "Sanal Oyun Kuponlar\u0131m" }), void 0), _jsx("ul", __assign({ className: "tabs mb-0 list-unstyled" }, { children: _jsx("li", __assign({ className: "cursor-pointer badge bg-primary p-2", onClick: function () { return navigate('/hesabim/sanal-oyun/'); } }, { children: "T\u00FCm\u00FC" }), void 0) }), void 0)] }), void 0), _jsx("div", __assign({ id: "InfiniteScroll", className: "body p-0" }, { children: _jsx(ListCoupons, {}, void 0) }), void 0)] }), void 0));
};
export var ListCoupons = function () {
    var _a = useState([]), tickets = _a[0], setTickets = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(0), page = _c[0], setPage = _c[1];
    var _d = useState({ total_page: 0, current_page: 0 }), pagination = _d[0], setPagination = _d[1];
    var _e = useState(null), expandedId = _e[0], setExpandedId = _e[1];
    var loadData = function (pageNum, isFirstLoad) {
        if (isFirstLoad === void 0) { isFirstLoad = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var api, res, processedData_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        api = new ApiService();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, api.start('post', "".concat(env.core_api, "/games/api/list-coupon/"), {
                                token: Storage.get('token'),
                                vendor: "6,10",
                                detail: true,
                                page: pageNum,
                            }, true, 30000)];
                    case 2:
                        res = _a.sent();
                        if (res === null || res === void 0 ? void 0 : res.data) {
                            processedData_1 = res.data.map(function (item) {
                                if (item.game_id === 28)
                                    return item;
                                if (typeof item.coupon_detail === 'string') {
                                    try {
                                        var validJson = item.coupon_detail
                                            .replace(/'/g, '"')
                                            .replace(/False/g, 'false')
                                            .replace(/True/g, 'true');
                                        item.coupon_detail = JSON.parse(validJson);
                                    }
                                    catch (_a) {
                                        item.coupon_detail = [];
                                    }
                                }
                                return item;
                            });
                            setTickets(function (prev) { return isFirstLoad ? processedData_1 : __spreadArray(__spreadArray([], prev, true), processedData_1, true); });
                            if (res.metadata) {
                                setPagination({
                                    total_page: res.metadata.total_page,
                                    current_page: res.metadata.page
                                });
                                setPage(res.metadata.page);
                            }
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Veri yüklenirken hata oluştu:", error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    useEffect(function () {
        loadData(0, true);
    }, []);
    return (_jsxs("div", __assign({ className: "table-responsive" }, { children: [_jsxs("table", __assign({ className: "table custom-table mb-0" }, { children: [_jsx(Title, {}, void 0), _jsx("tbody", { children: tickets.map(function (ticket, index) {
                            var _a, _b, _c;
                            var status = STATUS_MAP[ticket.status] || { label: "Bilinmeyen", className: "bg-light text-dark" };
                            var rowKey = (_b = (_a = ticket.integrator_transaction_id) !== null && _a !== void 0 ? _a : ticket.transaction_id) !== null && _b !== void 0 ? _b : String(ticket.id);
                            var hasDetail = ticket.game_id !== 28;
                            var isExpanded = hasDetail && expandedId === rowKey;
                            return (_jsxs(React.Fragment, { children: [_jsxs("tr", __assign({ className: "align-middle border-bottom".concat(hasDetail ? ' cursor-pointer' : ''), onClick: function () { return hasDetail && setExpandedId(isExpanded ? null : rowKey); } }, { children: [_jsx("td", __assign({ className: "text-center d-none d-md-table-cell small text-muted font-monospace" }, { children: (_c = ticket.integrator_transaction_id) !== null && _c !== void 0 ? _c : ticket.transaction_id }), void 0), _jsx("td", __assign({ className: "text-center small" }, { children: dateTimeFormat(ticket.transaction_date) }), void 0), _jsxs("td", __assign({ className: "text-center fw-bold" }, { children: [ticket.amount, " \u20BA"] }), void 0), _jsx("td", __assign({ className: "text-center" }, { children: status.label }), void 0)] }), void 0), isExpanded && (_jsx("tr", { children: _jsx("td", __assign({ colSpan: 4, className: "p-0 border-0 bg-light" }, { children: _jsxs("div", __assign({ className: "p-3 shadow-inner mx-2 my-2 bg-white rounded border" }, { children: [Array.isArray(ticket.coupon_detail) && ticket.coupon_detail.map(function (det, dIdx) { return (_jsxs("div", __assign({ className: "d-flex align-items-center py-2 border" }, { children: [_jsx("div", __assign({ className: "bg-light text-dark text-center p-2 rounded me-3", style: { minWidth: '75px' } }, { children: _jsx("div", __assign({ className: "fw-bold small", style: { fontSize: '10px' } }, { children: dateFormat(det.eventStartDate) }), void 0) }), void 0), _jsxs("div", __assign({ className: "flex-grow-1" }, { children: [_jsx("div", __assign({ className: "text-primary fw-bold", style: { fontSize: '11px' } }, { children: DISCIPLINE_MAP[det.disciplineName] || det.disciplineName }), void 0), _jsx("div", __assign({ className: "fw-bold", style: { fontSize: '13px' } }, { children: det.eventName }), void 0), _jsxs("div", __assign({ className: "small text-muted" }, { children: [det.marketName, ": ", _jsxs("strong", __assign({ className: "text-dark" }, { children: [det.selectionName, " (", det.odds, ")"] }), void 0)] }), void 0)] }), void 0)] }), dIdx)); }), _jsx("div", __assign({ className: "mt-3 pt-2 d-flex justify-content-end align-items-end border-top" }, { children: _jsxs("div", __assign({ className: "text-end" }, { children: [_jsxs("div", __assign({ className: "small" }, { children: ["Bahis: ", _jsxs("strong", { children: [ticket.amount, " \u20BA"] }, void 0)] }), void 0), Number(ticket.winning) > 0 && (_jsxs("div", __assign({ className: "text-success fw-bold" }, { children: ["Kazan\u00E7: ", ticket.winning, " \u20BA"] }), void 0))] }), void 0) }), void 0)] }), void 0) }), void 0) }, void 0))] }, "".concat(rowKey, "-").concat(index)));
                        }) }, void 0)] }), void 0), loading && (_jsx("div", __assign({ className: "text-center py-4" }, { children: _jsx("div", { className: "spinner-border spinner-border-sm text-primary" }, void 0) }), void 0)), !loading && pagination.current_page < pagination.total_page && (_jsx("div", __assign({ className: "p-3 text-center" }, { children: _jsx("button", __assign({ className: "btn btn-outline-primary btn-sm px-5 rounded-pill", onClick: function () { return loadData(page + 1); } }, { children: "Daha Fazla Y\u00FCkle" }), void 0) }), void 0))] }), void 0));
};
var Title = function () { return (_jsx("thead", __assign({ className: "bg-light" }, { children: _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-center d-none d-md-table-cell py-3" }, { children: "Bilet ID" }), void 0), _jsx("th", __assign({ className: "text-center py-3" }, { children: "Tarih" }), void 0), _jsx("th", __assign({ className: "text-center py-3" }, { children: "Tutar" }), void 0), _jsx("th", __assign({ className: "text-center py-3" }, { children: "Durum" }), void 0)] }, void 0) }), void 0)); };
export default VRGameCoupons;
